// extracted by mini-css-extract-plugin
module.exports = {"machineSearchResultWrapper":"styles_machineSearchResultWrapper__2Fh0W"};